export default onHydrationEnd;

function onHydrationEnd(pageContext: Vike.PageContext) {
  const body = typeof document !== 'undefined' && document.querySelector('body');

  body!.classList.add('page-is-interactive');

  // Seed the rendered URL that onPageTransitionEnd keeps current, so
  // onPageTransitionStart can tell a same-page pop apart on the first page too.
  const urlOriginal = pageContext?.urlOriginal || pageContext?.urlParsed?.pathnameOriginal;
  if (urlOriginal && typeof document !== 'undefined') {
    document.documentElement.dataset.urlOriginal = urlOriginal;
  }
}
